import { createSelector } from "@reduxjs/toolkit";
import { IMaconomyProject, IProjectPns } from "@schemas/projectSchema";
import { openapi } from "../../openapi";
import { selectCurrentProjectId } from "../global/globalSliceCommon";
import { MULTICONSULT_MAL_PROJECT_ID } from "../mc-shared/sharedConstants";
import { IRootState } from "../store";
import { projectRTK } from "./projectRTK";

export const selectHttpGetSingleProject = createSelector(
  [selectCurrentProjectId, (state) => state],
  (projectId, state) => {
    if (!projectId) return null;
    return projectRTK.endpoints.getProject.select(projectId)(state).data || null;
  },
);

const selectProjectNoFromDepricated = (s: IRootState) => s.adminReducer.project?.maconomy?.projectNo || null;
export const selectProjectNo = createSelector(
  [selectHttpGetSingleProject, selectProjectNoFromDepricated],
  (project, deprecatedProjectNo) => {
    if (project?.maconomy?.projectNo != null) return project.maconomy.projectNo;
    return deprecatedProjectNo;
  },
);

export const selectProjectPns = createSelector(
  [selectHttpGetSingleProject],
  (project): IProjectPns => project?.pns ?? [],
);

export const selectIsTemplateProject = createSelector([selectCurrentProjectId], (projectId) => {
  if (projectId === MULTICONSULT_MAL_PROJECT_ID) return true;
  return false;
});

export const selectHttpProjectMembers = createSelector(
  [selectCurrentProjectId, (state) => state],
  (projectId, state) => {
    if (!projectId) return [];
    return openapi.endpoints.getProjectMembers.select({ projectId })(state).data || [];
  },
);

export const selectMergedProjectList = createSelector([(state) => state], (state) => {
  const mcappsProjects = openapi.endpoints.getProjectsMcapps.select()(state).data;
  const maconomyProjects = openapi.endpoints.getProjectsMaconomy.select()(state).data;

  const _p = mcappsProjects?.map((p) => p.maconomy) || [];
  const _m = maconomyProjects || [];

  const mergedProjects: IMaconomyProject[] = Array.from(
    // _m, _p order matters here - we want to prefer mcapps projects over maconomy projects
    new Map([..._m, ..._p].map((item) => [item.projectNo.toString(), item])).values(),
  );

  return mergedProjects.sort((a, b) => a.name.localeCompare(b.name));
});
